import React from 'react';
import PortrSDK from 'portr-javascript-sdk';
const portrSDK = new PortrSDK();
// models
import IDriverTrackingStatus from '../../models/driver-tracking-status.interface';
import ILocation from '../../models/location.interface';
import { computeZoomKeepingDestCentered } from 'src/utils/helperFunctions';
// styles
const styles = require('./arrival-driver-map.scss');

interface IProps {
  locationData: ILocation;
  driverData: IDriverTrackingStatus;
  locationType: string;
  language: string;
  multiLang: any;
}

interface IState {
  location: ILocation;
  driver: IDriverTrackingStatus;
  locationType: string;
}

class ArrivalDriverMapComponent extends React.Component<IProps, IState> {
  private markerArr: Array<any> = [];
  private markerDriver = null;
  private markerLocation = null;
  public map: any = null;

  constructor(props: IProps) {
    super(props);
    this.state = {
      location: props.locationData,
      driver: props.driverData,
      locationType: props.locationType,
    };
  }

  componentDidMount() {
    if (!(window as any).google) {
      const s = document.createElement('script');
      s.type = 'text/javascript';
      s.src =
        'https://maps.google.com/maps/api/js?key=AIzaSyCyW4uJWHpGOMJZn_81xm-_PkvY_NH-Dm4';
      const x = document.getElementsByTagName('script')[0];
      x.parentNode.insertBefore(s, x);
      s.addEventListener('load', (e) => {
        this.onScriptLoad();
      });
    } else {
      this.onScriptLoad();
    }
  }

  componentDidUpdate() {
    if (
      (window as any).google &&
      this.state.driver.driverInfo.geoCoord &&
      this.state.location.geoCoord
    ) {
      this.updateDriverPosition();
    }
  }

  componentWillReceiveProps(props: IProps) {
    if (props.driverData !== null && props.locationData !== null) {
      this.setState({ location: props.locationData });
      this.setState({ driver: props.driverData });
    }
  }

  onScriptLoad() {
    this.map = portrSDK.getGoogleMap({
      latitude: this.state.location?.geoCoord?.latitude,
      longitude: this.state.location?.geoCoord?.longitude,
    });
    this.map.setOptions({ minZoom: 15, maxZoom: 16 });

    this.setMarkers();
  }

  updateDriverPosition() {
    if (this.markerDriver === null) {
      this.setMarkers();
    } else {
      this.markerDriver.setPosition(
        new (window as any).google.maps.LatLng(
          this.state.driver.driverInfo.geoCoord.latitude,
          this.state.driver.driverInfo.geoCoord.longitude
        )
      );

      this.markerArr = [this.markerLocation, this.markerDriver];
      this.setMapBounds();
      this.setZoom();
    }
  }

  setMapBounds() {
    if (this.markerArr.length === 0) {
      return;
    }
    const bounds = new (window as any).google.maps.LatLngBounds();
    for (const m of this.markerArr) {
      bounds.extend(m.getPosition());
    }
    this.map.setCenter(this.markerArr[0].getPosition());
    // this.map.fitBounds(bounds, { top: 100, right: 32, bottom: 200, left: 32 });
  }

  setZoom() {
    const mapEl = document.getElementById('map');
    const width = mapEl ? mapEl.clientWidth : 360;
    const height = mapEl ? mapEl.clientHeight : 320; // your container height2

    const dest = this.state.location.geoCoord;
    const driver = this.state.driver.driverInfo.geoCoord;

    const zoom = computeZoomKeepingDestCentered(
      dest.latitude,
      dest.longitude,
      driver.latitude,
      driver.longitude,
      width,
      height,
      { left: 20, right: 20, top: 20, bottom: 20 }, // tune for your overlay sizes
      5,
      16,
      0.9
    );
    this.map.setZoom(zoom);
  }

  setMarkers() {
    if (this.state.location !== null) {
      this.markerLocation = portrSDK.getGoogleMapMarker({
        map: this.map,
        geo: {
          latitude: this.state.location?.geoCoord?.latitude,
          longitude: this.state.location?.geoCoord?.longitude,
        },
        icon:
          'https://portrlivecdnstorage.blob.core.windows.net/webimages/location.png',
      });
    }

    if (this.state.driver !== null) {
      try {
        this.markerDriver = portrSDK.getGoogleMapMarker({
          map: this.map,
          geo: {
            latitude: this.state.driver.driverInfo.geoCoord.latitude,
            longitude: this.state.driver.driverInfo.geoCoord.longitude,
          },
          icon:
            'https://portrlivecdnstorage.blob.core.windows.net/webimages/driver-location.png',
        });

        if (this.markerLocation !== null) {
          this.markerArr = [this.markerLocation, this.markerDriver];
        } else {
          this.markerArr = [this.markerDriver];
        }

        this.setMapBounds();
        this.setZoom();
      } catch (error) {
        console.log('has no geo coords');
      }
    }
  }

  public render() {
    const { language, multiLang } = this.props;
    return (
      <div className={styles.driverMapWrapper}>
        <div id='map' className={styles.map}></div>
        {this.state.driver.etaDisplay !== null ? (
          <div className={styles.timeslot}>
            <h2>{this.state.driver.etaDisplay}</h2>
            <p className={styles.caption}>
              {this.state.locationType === 'collection'
                ? multiLang[`pickUpETAText${language}`]
                : multiLang[`deliveryETAText${language}`]}
            </p>
          </div>
        ) : null}
      </div>
    );
  }
}

export default ArrivalDriverMapComponent;



// WEBPACK FOOTER //
// ./src/components/arrival-driver-map/arrival-driver-map.tsx